import React from "react";
import Skeleton from "react-loading-skeleton";

const MenuStripesLoader = (props) => {
    const { width = '90%', sectionItems = [2] } = props;
    const sections = sectionItems.length;
    return (
        <>
            <div className="circular-skeleton-flex">
                <Skeleton
                    circle
                    className="circular-skeleton"
                    height="108px"
                    width="108px"
                ></Skeleton>
            </div>
            {
                Array.from({ length: sections }).map((_, countIndex) => (
                <div key={countIndex} className="menu-section-skeleton">
                    {
                        Array.from({ length: sectionItems[countIndex] }).map((_, index) => (
                            <div className="row" key={index}>
                                <div className="col-2">
                                    <Skeleton className="square-skeleton" />
                                </div>
                                <div className="col-10 stripe">
                                    <Skeleton width={width} />
                                </div>
                            </div>
                        ))
                    }
                </div>
                ))
            }
        </>
    )
}

export default MenuStripesLoader